import request from "@/utils/request";
export function provinces(data) {
    return request({
        url: '/api/portal/v1/region/findRegion',
        method: 'post',
        data
    })
}
export function citys(data) {
    return request({
        url: '/api/portal/v1/region/selectRegion',
        method: 'post',
        data
    })
}
export function areaitem(data) {
    return request({
        url: '/api/portal/v1/region/selectRegion',
        method: 'post',
        data
    })
}
export function addcompany(data) {
    return request({
        url: '/api/portal/v1/company/addNew',
        method: 'post',
        data
    })
}